// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__1qekU","insightsList":"newBusinessInsightsMenu_insightsList__2Hghs","active":"newBusinessInsightsMenu_active__9u9zQ"};